import { render, staticRenderFns } from "./Pedidos.vue?vue&type=template&id=ec2a913e&"
import script from "./Pedidos.vue?vue&type=script&lang=js&"
export * from "./Pedidos.vue?vue&type=script&lang=js&"
import style0 from "./Pedidos.vue?vue&type=style&index=0&id=ec2a913e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports